module.exports = __webpack_public_path__ + "static/img/ewm.7b91bd9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/ewm.png
// module id = 827
// module chunks = 0